<div class="eo-bg">
	<div class="eo-inner">

		<div class="eo-header-row">
			<div style="display:flex; align-items:center; gap:20px;">
				<img src="assets/Logo.png" class="eo-logo" alt="BPL Logo">
				<div>
				<h1 class="eo-title">Employee Assignments</h1>
				<span class="eo-subtitle">
					Last Refresh: {{this.lastRefresh}}
					<span class="eo-subtitle-live">(Auto Refresh On)</span>
				</span>
				</div>
			</div>
			<div class="eo-count-badge">
				<span class="eo-count-number">{{employees.length}}</span>
				<span class="eo-count-label">On Machine</span>
			</div>
		</div>

		<div class="eo-columns">

			<!-- Left column -->
			<div class="eo-table-wrapper">
				<table class="eo-table">
					<thead>
						<tr>
							<th class="eo-th">Employee</th>
							<th class="eo-th">Machine</th>
							<th class="eo-th">Part Number</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let emp of employees | slice:0:halfCount" class="eo-tr">
							<td class="eo-td">
								<div class="eo-employee-cell">
									<div *ngIf="emp.profileImage" class="eo-avatar-wrap">
										<img [src]="emp.profileImage" class="eo-avatar" />
									</div>
									<div *ngIf="!emp.profileImage" class="eo-avatar-wrap">
										<div class="eo-avatar-initials">{{getInitials(emp.fullName)}}</div>
									</div>
									<span class="eo-employee-name">{{emp.fullName}}</span>
								</div>
							</td>
							<td class="eo-td">
								<span class="eo-machine-badge">{{emp.machineName}}</span>
							</td>
							<td class="eo-td">
								<span class="eo-text-white">{{emp.partNumber?.slice(0, 20)}}</span>
							</td>
						</tr>
						<tr *ngIf="employees.length === 0">
							<td colspan="3" class="eo-empty">No employees currently assigned to a machine.</td>
						</tr>
					</tbody>
				</table>
			</div>

			<!-- Right column -->
			<div class="eo-table-wrapper">
				<table class="eo-table">
					<thead>
						<tr>
							<th class="eo-th">Employee</th>
							<th class="eo-th">Machine</th>
							<th class="eo-th">Part Number</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let emp of employees | slice:halfCount" class="eo-tr">
							<td class="eo-td">
								<div class="eo-employee-cell">
									<div *ngIf="emp.profileImage" class="eo-avatar-wrap">
										<img [src]="emp.profileImage" class="eo-avatar" />
									</div>
									<div *ngIf="!emp.profileImage" class="eo-avatar-wrap">
										<div class="eo-avatar-initials">{{getInitials(emp.fullName)}}</div>
									</div>
									<span class="eo-employee-name">{{emp.fullName}}</span>
								</div>
							</td>
							<td class="eo-td">
								<span class="eo-machine-badge">{{emp.machineName}}</span>
							</td>
							<td class="eo-td">
								<span class="eo-text-white">{{emp.partNumber?.slice(0, 20)}}</span>
							</td>
						</tr>
						<tr *ngIf="employees.length === 0">
							<td colspan="3" class="eo-empty"></td>
						</tr>
					</tbody>
				</table>
			</div>

		</div>

	</div>
</div>
